// Module
var code = `<div class="breadcrumbs" ng-class="{'breadcrumbs--hidden': \$ctrl.breadcrumbsHidden}">
  <a ng-repeat="breadcrumb in \$ctrl.breadcrumbs.get() track by breadcrumb.path"
     ng-href="{{ '#!' + breadcrumb.path }}"
     ng-if="breadcrumb.label != '<null>'"
     ng-class="{'breadcrumbs__item--trimmed': \$ctrl.shouldTrimLabel(breadcrumb.label)}"
     class="breadcrumbs__item"
     title="{{ \$ctrl.shouldTrimLabel(breadcrumb.label) ? \$ctrl.getLabel(breadcrumb.label) : null }}">
    {{ \$ctrl.getLabel(breadcrumb.label) }}
  </a>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/breadcrumbs/breadcrumbs.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;